// @flow
import React from 'react';
import serialize from 'serialize-javascript';

type Props = {
  data: {
    '@type': string,
  },
};

const LdJson = ({ data }: Props) => (
  <script
    dangerouslySetInnerHTML={{
      __html: serialize(
        {
          '@context': 'https://schema.org',
          ...data,
        },
        {
          isJSON: true,
        }
      ),
    }}
    type="application/ld+json"
  />
);

export default LdJson;
